'use strict';

export const statusMap = {
  1: `Pending`,
  2: `Approved`,
  3: `Denied`,
};



// WEBPACK FOOTER //
// ./client/models/reviewer.js